import Vue from "vue";
import VueRouter from "vue-router";
import VueCookie from "vue-cookie";
import config from "@/utils/config";

Vue.use(VueRouter);

const arr = localStorage.getItem("sysEntMenus");

const routes = [
  {
    path: "/home",
    name: "home",
    component: () => import("../views/HomeView.vue"),
    children: [
      {
        path: "/questionManagement",
        name: "questionManagement",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/questionManagement/questionManagement"),
      },
      {
        path: "/questionManagement_product",
        name: "questionManagement_product",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/questionManagement/questionManagement_product"),
      },
      {
        path: "/capabilityItemManagement",
        name: "capabilityItemManagement",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/capabilityModeling/management/index"),
      },
      {
        path: "/questionManagement/questionDetails",
        name: "questionDetails",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/questionManagement/questionDetails"),
      },
      {
        path: "/questionManagement/questionDetails_product",
        name: "questionDetails_product",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/questionManagement/questionDetails_product"),
      },
      {
        path: "/postEngine",
        name: "postEngine",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/postEngine/postEngine"),
      },
      {
        path: "/performanceResults",
        name: "performanceResults",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/performanceResults/performanceResults"),
      },
      {
        path: "/versionService",
        name: "versionService",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/versionService"),
      },
      {
        path: "/courseClassification",
        name: "courseClassification",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/course/courseClassification"),
      },
      {
        path: "/courseList",
        name: "courseList",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/course/courseList"),
      },
      // {
      //   path: "/zoneList",
      //   name: "zoneList",
      //   meta: {
      //     isLogin: true,
      //   },
      //   component: () => import("../views/zoneList/zoneList.vue"),
      // },
      {
        path: "/enterpriseList",
        name: "enterpriseList",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/enterpriseList/enterpriseList.vue"),
      },
      {
        path: "/enterprise/category",
        name: "enterpriseCategory",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/enterpriseList/enterpriseCategory.vue"),
      },
      {
        path: "/teacherLists",
        name: "teacherLists",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/teacherLists/teacherLists.vue"),
      },
      {
        path: "/teacherList",
        name: "teacherList",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/teacherList/teacherList"),
      },
      {
        path: "/evaluation",
        name: "evaluation",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/questionManagement/evaluation"),
      },
      {
        path: "/evaluation_product",
        name: "evaluation_product",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/questionManagement/evaluation_product"),
      },
      {
        path: "/evaluation/evaluationDetails",
        name: "evaluationDetails",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/questionManagement/evaluationDetail"),
      },
      {
        path: "/evaluation/evaluationDetails_product",
        name: "evaluationDetails_product",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/questionManagement/evaluationDetail_product"),
      },
      {
        path: "/paperResource/resourceClassification",
        name: "resourceClassification",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/paperResource/resourceClassification"),
      },
      {
        path: "/paperResource/topicPoolManagement",
        name: "topicPoolManagement",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/paperResource/topicPoolManagement"),
      },
      {
        path: "/paperResource/resourceClassification_product",
        name: "resourceClassification_product",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/paperResource/resourceClassification_product"),
      },
      {
        path: "/paperResource/topicPoolManagement_product",
        name: "topicPoolManagement_product",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/paperResource/topicPoolManagement_product"),
      },
      {
        path: "/paperResource/examManagement",
        name: "examManagement",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/paperResource/examManagement/examManagement.vue"),
      },
      {
        path: "/paperResource/topicPoolDetails",
        name: "topicPoolDetails",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/paperResource/topicPoolDetails"),
      },
      {
        path: "/paperResource/topicDetail",
        name: "topicDetail",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/paperResource/topicDetail"),
      },
      {
        path: "/teacherBatch",
        name: "teacherBatch",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/teacherList/teacherBatch"),
      },
      {
        path: "/capabilityItemManagement",
        name: "capabilityItemManagement",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/capabilityModeling/management/index"),
      },
      {
        path: "/capabilityModelBase",
        name: "capabilityModelBase",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/capabilityModeling/modelBase/index"),
      },
      {
        path: "/sourceMaterial/imageManager",
        name: "imageManager",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/sourceMaterial/imageManager/imageManager"),
      },
      {
        path: "/sourceMaterial/audioManager",
        name: "audioManager",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/sourceMaterial/audioManager/audioManager"),
      },
      {
        path: "/document/library",
        name: "documentLibrary",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/sourceMaterial/document/library"),
      },
      {
        path: "/sourceMaterial/videoManager",
        name: "videoManager",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/sourceMaterial/videoManager/videoManager"),
      },
      {
        path: "/sourceMaterial/imageManager_product",
        name: "imageManager_product",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/sourceMaterial/imageManager_product/imageManager_product"),
      },
      {
        path: "/sourceMaterial/audioManager_product",
        name: "audioManager_product",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/sourceMaterial/audioManager_product/audioManager_product"),
      },
      {
        path: "/document/library_product",
        name: "documentLibrary_product",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/sourceMaterial/document_product/library_product"),
      },
      {
        path: "/sourceMaterial/videoManager_product",
        name: "videoManager_product",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/sourceMaterial/videoManager_product/videoManager_product"),
      },
      {
        path: "/enterprise/enterprise",
        name: "enterpriseView",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/enterprise/enterprise"),
      },
      {
        path: "/authority",
        name: "authority",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/authority/index"),
      },
      {
        path: "/configuration",
        name: "configuration",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/configuration/index"),
      },
      {
        path: "/configuration/sealconfig",
        name: "sealconfig",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/configuration/sealconfig"),
      },

      {
        path: "/jur/jur",
        name: "jurisdictionView",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/jurisdiction/jurisdiction"),
      },
      {
        path: "/role/role",
        name: "roleView",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/jurisdiction/role"),
      },
      {
        path: "/menuManagement",
        name: "menuManagement",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/jurisdiction/menuManagement"),
      },
      {
        path: "/order/orderList",
        name: "orderList",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/order/orderList"),
      },
      {
        path: "/template/list",
        name: "templates",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/template/templateList"),
      },
      {
        path: "/template/learnProject",
        name: "learnProjectTemplate",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/template/learnProjectTemplate"),
      },
      {
        path: "/efficiency/questionnaireManage",
        name: "questionnaireManage",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/efficiency/personal/questionnaireManage"),
      },
      {
        path: "/efficiency/questionnaireData",
        name: "questionnaireData",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/efficiency/personal/questionnaireData"),
      },
      {
        path: "/efficiency/questionnaireConfig",
        name: "questionnaireConfig",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/efficiency/personal/questionnaireConfig"),
      },
      {
        path: "/learnProjectList",
        name: "learnProjectList",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/learnProject/learnProjectList"),
      },
      {
        path: "/classPackageList",
        name: "classPackageList",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/classPackage/classPackageList"),
      },
      {
        path: "/efficiency/companyQuestionnaireManage",
        name: "questionnaireManage",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/efficiency/company/questionnaireManage"),
      },
      {
        path: "/customerManagement/list",
        name: "customerManagementList",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/customerManagement/customerManagement.vue"),
      },
      {
        path: "/customerManagement/ecologyList",
        name: "customerManagementEcologyList",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/customerManagement/ecologyList.vue"),
      },
      {
        path: "/dataCentral/courseStatistics",
        name: "dataCentralCourseStatistics",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/dataCentral/courseStatistics.vue"),
      },
      {
        path: "/dataCentral/orderStatistics",
        name: "dataCentralOrderStatistics",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/dataCentral/orderStatistics.vue"),
      },
      {
        path: "/dataCentral/incomeStatistics",
        name: "dataCentralincomeStatistics",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/dataCentral/incomeStatistics.vue"),
      },
      {
        path: "/config/configStatistics",
        name: "configStatistics",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/config/configStatistics"),
      },
      {
        path: "/dataCentral/courseDetail",
        name: "courseDetail",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/dataCentral/courseDetail.vue"),
      },
    ],
  },
  {
    path: "/efficiency/exportPDf",
    name: "questionnaireExportPDf",
    meta: {
      isLogin: true,
    },
    component: () => import("../views/efficiency/company/questionnaireExportPDf"),
  },
  {
    path: "/order",
    name: "orderView",
    component: () => import("../views/order/order"),
    children: [
      {
        path: "/order/createOrder",
        name: "createOrder",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/order/createOrder"),
      },
      {
        path: "/order/orderDetails",
        name: "orderDetails",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/order/orderDetails"),
      },
      {
        path: "/order/orderDetailsNew",
        name: "orderDetailsNew",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/order/orderDetailsNew"),
      },
    ],
  },
  {
    path: "/homeNoMenuView",
    name: "homeNoMenu",
    component: () => import("../views/HomeNoMenu.vue"),
    children: [
      {
        path: "/capabilityModel/edit",
        name: "capabilityModelEdit",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/capabilityModeling/modelBase/edit"),
      },
      {
        path: "/createLearn",
        name: "createLearn",
        component: () => import("../views/template/createLearn"),
      },
      {
        path: "/createClasspackage",
        name: "createClasspackage",
        component: () => import("../views/template/createClasspackage"),
      },
      {
        path: "/addEnterprise",
        name: "addEnterprise",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/enterpriseList/addEnterprise.vue"),
      },
      {
        path: "/addTeacher",
        name: "addTeacher",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/teacherList/addTeacher.vue"),
      },
      {
        path: "/createCourse",
        name: "createCourse",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/course/createCourse"),
      },
      {
        path: "/courseContentLayout",
        name: "courseContentLayout",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/course/courseContentLayout"),
        children: [
          {
            path: "/courseContent",
            name: "createCourse",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/course/createCourse"),
          },
          {
            path: "/course/courseSet",
            name: "courseSet",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/course/course/courseSet"),
          },
          {
            path: "/course/courseDir",
            name: "courseDir",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/course/course/courseDirectoryView"),
          },
          {
            path: "/course/applicationSet",
            name: "applicationSet",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/course/course/courseForm"),
          },
          {
            path: "/course/priceSet",
            name: "priceSet",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/course/course/priceSet"),
          },
        ],
      },
      {
        path: "/createCourseTemplate",
        name: "createCourseTemplate",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/template/course/createCourse"),
      },
      {
        path: "/courseContentLayout",
        name: "courseContentLayout",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/template/course/courseContentLayout"),
        children: [
          {
            path: "/courseContentTemplate",
            name: "createCourseTemplate",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/template/course/createCourse"),
          },
          {
            path: "/template/courseSet",
            name: "courseSetTemplate",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/template/course/course/courseSet"),
          },
          {
            path: "/template/courseDir",
            name: "courseDirTemplate",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/template/course/course/courseDirectoryView"),
          },
          {
            path: "/template/applicationSet",
            name: "applicationSetTemplate",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/template/course/course/courseForm"),
          },
        ],
      },
      {
        path: "/createArticleResource",
        name: "createArticleResource",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/course/createArticleResource"),
      },
      {
        path: "/createAudioResource",
        name: "createAudioResource",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/course/createAudioResource"),
      },
      {
        path: "/createVideoResource",
        name: "createVideoResource",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/course/createVideoResource"),
      },
      {
        path: "/enterprise/enterpriseDetails",
        name: "enterpriseDetails",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/enterprise/enterpriseDetails"),
      },
      //创建问卷调查
      {
        path: "/createSurvey",
        name: "createSurvey",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/course/createSurvey"),
        children: [
          {
            path: "/createSurvey/survey",
            name: "surveyView",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/course/createSurvey/questionDetails.vue"),
          },
          // {
          //   path: "/createSurvey/survey",
          //   name: "surveyView",
          //   meta: {
          //     isLogin: true,
          //   },
          //   component: () => import("../views/courseSection/createSurvey/questionDetails.vue"),
          // },
          {
            path: "/createSurvey/surveySet",
            name: "surveySet",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/course/createSurvey/surveySet"),
          },
          {
            path: "/createSurvey/surveyStatistics",
            name: "surveyStatistics",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/course/createSurvey/surveyStatistics"),
          },
        ],
      },
      {
        path: "/exam",
        name: "exam",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/course/exam"),
        children: [
          {
            path: "/exam/examEditTwo",
            name: "examEditTwo",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/course/examTwo/examEditTwo.vue"),
          },
          {
            path: "/exam/examEdit",
            name: "examEdit",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/course/exam/examEdit"),
          },
          {
            path: "/exam/examSet",
            name: "examSet",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/course/exam/examSet"),
          },
          {
            path: "/exam/examResult",
            name: "examResult",
            meta: {
              isLogin: true,
            },
            component: () => import("../views/course/exam/examResult"),
          },
        ],
      },
      {
        path: "/learnProject/detail",
        name: "learnProjectDetail",
        component: () => import("../views/template/learnProject/learnProjectDetail"),
        children: [
          {
            path: "/learnProject/learnBasicInfo",
            name: "learnBasicInfo",
            component: () => import("../views/template/learnProject/learnBasicInfo"),
          },
          {
            path: "/learnProject/pointSetting",
            name: "pointSetting",
            component: () => import("../views/template/learnProject/pointSetting"),
          },
          {
            path: "/learnProject/learnProjectSet",
            name: "learnProjectSet",
            component: () => import("../views/template/learnProject/learnProjectSet"),
          },
          // {
          //   path: "/learnProject/learnProjectGroup",
          //   name: "learnProjectGroup",
          //   component: () => import("../views/template/learnProject/learnProject/learnProjectGroup"),
          // },
          // {
          //   path: "/learnProject/learnClass",
          //   name: "learnClass",
          //   component: () => import("../views/template/learnProject/learnProject/learnClass"),
          // },
          // {
          //   path: "/learnProject/learnStudent",
          //   name: "learnStudent",
          //   component: () => import("../views/template/learnProject/learnProject/learnStudent"),
          // },
          // {
          //   path: "/learnProject/learnStudentDetail",
          //   name: "learnStudentDetail",
          //   component: () => import("../views/template/learnProject/learnProject/learnStudentDetail"),
          // },
          // {
          //   path: "/learnProject/activityStatistics",
          //   name: "activityStatistics",
          //   component: () => import("../views/template/learnProject/learnProject/activityStatistics"),
          // },
          // {
          //   path: "/learnProject/clockStatistics",
          //   name: "clockStatistics",
          //   component: () => import("../views/template/learnProject/learnProject/clockStatistics"),
          // },
          // {
          //   path: "/learnProject/articleStatistics",
          //   name: "articleStatistics",
          //   component: () => import("../views/template/learnProject/learnProject/articleStatistics"),
          // },
          // {
          //   path: "/learnProject/audioStatistics",
          //   name: "audioStatistics",
          //   component: () => import("../views/template/learnProject/learnProject/audioStatistics"),
          // },
          // {
          //   path: "/learnProject/questionnaireStatistics",
          //   name: "questionnaireStatistics",
          //   component: () => import("../views/template/learnProject/learnProject/questionnaireStatistics"),
          // },
          // {
          //   path: "/learnProject/courseStatistics",
          //   name: "courseStatistics",
          //   component: () => import("../views/template/learnProject/learnProject/courseStatistics"),
          // },
          // {
          //   path: "/learnProject/examStatistics",
          //   name: "examStatistics",
          //   component: () => import("../views/template/learnProject/learnProject/examStatistics"),
          // },
          // {
          //   path: "/learnProject/videoStatistics",
          //   name: "videoStatistics",
          //   component: () => import("../views/template/learnProject/learnProject/videoStatistics"),
          // },
          // {
          //   path: "/learnProject/workStatistics",
          //   name: "workStatistics",
          //   component: () => import("../views/template/learnProject/learnProject/workStatistics"),
          // },
        ],
      },
      {
        path: "/classPackage/detail",
        name: "classPackageDetail",
        component: () => import("../views/template/classPackage/classPackageDetail"),
        children: [
          {
            path: "/classPackage/classPackageBasicInfo",
            name: "learnBasicInfo",
            component: () => import("../views/template/classPackage/classPackageBasicInfo"),
          },
          {
            path: "/classPackage/classPackageSet",
            name: "classPackageSet",
            component: () => import("../views/template/classPackage/classPackageSet"),
          },
        ],
      },
    ],
  },
  {
    path: "/postEngineTitle",
    name: "postEngineTitle",
    component: () => import("../views/postEngine/postEngineTitle"),
  },
  {
    path: "/postEngineTabs",
    name: "postEngineTabs",
    component: () => import("../views/postEngine/postEngineTabs"),
  },
  {
    path: "/postEngineMain",
    name: "postEngineMain",
    component: () => import("../views/postEngine/postEngineMain"),
    children: [
      {
        path: "/postEngineMain/base",
        name: "basicInformation",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/postEngine/postEngineMain/basicInformation"),
      },
      {
        path: "/postEngineMain/postJob",
        name: "postJob",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/postEngine/postEngineMain/postJob"),
      },
      {
        path: "/postEngineMain/postStep",
        name: "postStep",
        meta: {
          isLogin: true,
        },
        component: () => import("../views/postEngine/postEngineMain/postStep"),
      },
    ],
  },
  {
    path: "/login",
    name: "loginView",
    component: () => import("../views/login/login"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/404"),
  },
  {
    path: "/",
    redirect: () => {
      return getRedirectPath();
    },
  },
  { path: "*", redirect: "/404" },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});
function getRedirectPath() {
  let path = "/performanceResults";
  if (arr) {
    let arr1 = JSON.parse(arr);
    path = getUrl(arr1);
    VueCookie.set("activeRouter", path);
    return path;
  } else {
    VueCookie.set("activeRouter", path);
    return path;
  }
}
function getUrl(obj) {
  for (let i = 0; i < obj.length; i++) {
    if (obj[i].path) {
      return obj[i].path;
    } else if (obj[i].subMenus && obj[i].subMenus.length > 0) {
      let path = getUrl(obj[i].subMenus);
      if (path) return path;
    }
  }
}
router.beforeEach((to, from, next) => {
  if (VueCookie.get(config.cooKey)) {
    if (to.path === "/" && arr) {
      let arr1 = JSON.parse(arr);
      let path = getUrl(arr1);
      VueCookie.set("activeRouter", path);
      next({
        path: path,
      });
    } else {
      next();
    }
  } else {
    if (to.path === "/login") {
      next();
    } else {
      next("/login");
    }
  }
});

export default router;
